
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1152:507)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#28A920"}}),_c('path',{attrs:{"d":"M33.212 22.9c.3-.3.5-.7.5-1.2 0-1-.8-1.8-1.8-1.8h-3.403c.3-1 .5-2.4.5-3v-.5c0-1.3-1.1-2.4-2.401-2.4h-.6c-.3 0-.501.2-.601.4l-.3 1.3c-.4 1.8-1.902 3.8-3.403 4.1-.3-.7-.9-1.1-1.6-1.1H16.6c-.3 0-.6.3-.6.6v10.6c0 .3.3.6.6.6h3.502c.7 0 1.301-.4 1.601-1l2.002.7c.7.2 1.4.3 2.001.3h4.904c1 0 1.8-.8 1.8-1.8 0-.2 0-.4-.1-.6.701-.2 1.302-.9 1.302-1.7 0-.5-.2-.9-.5-1.2.3-.3.5-.7.5-1.2.1-.4-.1-.8-.4-1.1zm-12.507 5.9c0 .3-.3.6-.6.6H17.2V20h2.902c.3 0 .6.3.6.6v8.2h.003z","fill":"#fff"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1152:507","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1152:507"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1152:507","result":"shape"}})])])])
          )
        }
      }
    